import {
    BID_PRODUCT,
    GET_VIEW_PRODUCT,
    GET_BID_HISTORY,
    RESPONSE_STATUS,
    CLEAR_RESPONSE,
    GET_ALL_BUYER,
    GET_ALL_TRANSACTION,
    GET_BUYERS_LIST,
    GET_CHAT_HISTORY,
    GET_SHIPPING_RATE,
    GET_MAKEREQUEST_LIST,
    CLEAR_BUYER_STATE,
    GET_MORE_VIEW_PRODUCT,
    SET_IMAGES,
    CLEAR_IMAGES,
    SET_GLOBAL_CHAT_USER,
    GET_ALL_AUCTIONS_DETAILS,
    GET_ALL_WAREHOUSE,
    GET_ALL_BUYER_TEMP,
} from './buyerTypes'

export default (state, action) => {
    switch (action.type) {
        case SET_GLOBAL_CHAT_USER:
            return {
                ...state,
                globalChatUser: action.payload,
            }
        case BID_PRODUCT:
            return {
                ...state,
                responseStatus: action.payload,
            }
        case GET_VIEW_PRODUCT:
            return {
                ...state,
                product_view: action.payload,
            }
        case GET_BID_HISTORY:
            return {
                ...state,
                product_bidhistory: action.payload,
            }
        case GET_ALL_BUYER:
            return {
                ...state,
                buyer_allproducts: action.payload,
            }
        case GET_ALL_BUYER_TEMP:
            return {
                ...state,
                buyer_allproducts_temp: action.payload,
            }
        case SET_IMAGES:
            return {
                ...state,
                message_images: action.payload,
            }
        case CLEAR_IMAGES:
            return {
                ...state,
                message_images: '',
            }
        case GET_ALL_TRANSACTION:
            return {
                ...state,
                buyer_alltransaction: action.payload,
            }
        case GET_BUYERS_LIST:
            return {
                ...state,
                list_buyers: action.payload,
            }
        case GET_CHAT_HISTORY:
            return {
                ...state,
                chat_history: action.payload,
            }
        case GET_SHIPPING_RATE:
            return {
                ...state,
                shipping_rate_calculation: action.payload,
            }
        case GET_MAKEREQUEST_LIST:
            return {
                ...state,
                list_make_request: action.payload,
            }
        case GET_ALL_AUCTIONS_DETAILS:
            return {
                ...state,
                all_auctions: action.payload.auctions || [],
            }
        case GET_ALL_WAREHOUSE:
            return {
                ...state,
                all_locations: action.payload.locations || [],
            }
        case RESPONSE_STATUS:
            return {
                ...state,
                responseStatus: action.payload,
            }
        case CLEAR_RESPONSE:
            return {
                ...state,
                responseStatus: '',
            }
        case GET_MORE_VIEW_PRODUCT:
            return {
                ...state,
                product_more_view: action.payload,
            }
        case CLEAR_BUYER_STATE:
            return {
                ...state,
                buyer_allproducts: {
                    results: [],
                    total_pagecnt: 0,
                    total_only: 0,
                },
            }
        default:
            return state
    }
}
